import * as theme from '../variables'
export { GlobalStyle } from './globalStyles'

export default theme
